<header class="dsDialog_header">
    <h2 class="subTitle"><i class="dsIcon"></i>Apps</h2>
</header>
<section class="dsDialog_content">
    <ul class="appDrawerWrap">
        <li class="appLogoWrap">
            <div class="appIcon">
                <figure>
                    <img src="../../../../resources/images/lnw-logo.svg" alt="">
                </figure>
            </div>            
            <span class="appTitle">Engage</span>
        </li>
    </ul>
    <ul class="dsAppsList" hidden>
        <li>
            <figure>
                <img src="../../../../resources/images/lnw-logo.svg" alt="">
            </figure>
            <div>Engage</div>
        </li>
    </ul>
</section>
